import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

function isCaixaExclusivo(perfis: string[]) {
  return perfis.length > 0 && perfis.every((p) => p === 'CAIXA');
}

/**
 * Se o utilizador tiver apenas perfil CAIXA, restringe navegação para rotas /pdv*.
 * Perfis combinados (ex.: ADMIN + CAIXA) mantêm acesso normal.
 */
export function CaixaOnlyPdvRouteGuard() {
  const { user } = useAuth();
  const { pathname } = useLocation();

  const perfis = user?.perfis ?? [];
  if (!isCaixaExclusivo(perfis)) return <Outlet />;

  if (pathname === '/pdv' || pathname.startsWith('/pdv/')) {
    return <Outlet />;
  }

  return <Navigate to="/pdv" replace />;
}
